export type LateCheckInReasonCode =
  | 'TRAFFIC'
  | 'WEATHER'
  | 'MECHANICAL'
  | 'HOS_DRIVER_REST'
  | 'PRIOR_STOP_DELAY'
  | 'ACCIDENT_ROAD_CLOSURE'
  | 'FACILITY_NOT_READY'
  | 'APPOINTMENT_RESCHEDULED'
  | 'GATE_CHECKIN_DELAY'
  | 'DRIVER_ERROR'
  | 'CARRIER_SCHEDULING_ERROR'
  | 'FREIGHT_NOT_READY'
  | 'OTHER'

export const LATE_CHECK_IN_REASON_OPTIONS: ReadonlyArray<{
  value: LateCheckInReasonCode
  label: string
}> = [
  { value: 'TRAFFIC', label: 'Traffic / road conditions' },
  { value: 'WEATHER', label: 'Weather delay' },
  { value: 'MECHANICAL', label: 'Mechanical breakdown / equipment issue' },
  {
    value: 'HOS_DRIVER_REST',
    label: 'Driver hours-of-service / required rest break',
  },
  { value: 'PRIOR_STOP_DELAY', label: 'Delay/detention at a previous stop' },
  { value: 'ACCIDENT_ROAD_CLOSURE', label: 'Accident or road closure' },
  {
    value: 'FACILITY_NOT_READY',
    label: 'Facility not ready (dock/door unavailable, yard congestion)',
  },
  {
    value: 'APPOINTMENT_RESCHEDULED',
    label: 'Appointment changed/rescheduled by facility',
  },
  {
    value: 'GATE_CHECKIN_DELAY',
    label: 'Gate, security, or guard-shack line delay',
  },
  {
    value: 'DRIVER_ERROR',
    label: 'Driver error (wrong address, missed turn, miscommunication)',
  },
  {
    value: 'CARRIER_SCHEDULING_ERROR',
    label: 'Carrier dispatch/scheduling error',
  },
  { value: 'FREIGHT_NOT_READY', label: 'Freight/load not ready at origin' },
  { value: 'OTHER', label: 'Other' },
]

export const REASON_NOTE_MAX_LENGTH = 100

export const LATE_CHECK_IN_REASON_REQUIRED_ERROR_CODE = 'invalid.late-check-in-reason-code-required'

export class LateCheckInReasonRequiredError extends Error {
  constructor(message: string, options?: { cause?: Error }) {
    super(message, options)
    this.name = 'LateCheckInReasonRequiredError'
  }
}

export function isLateCheckInReasonCode(value: string): value is LateCheckInReasonCode {
  return LATE_CHECK_IN_REASON_OPTIONS.some(option => option.value === value)
}
